// Shared context for admin routes: auth state + four-collection sync.

import type { AdminAuthState } from "./hooks/useAdminAuth";
import type { AdminSyncState } from "./hooks/useAdminSync";
import { createContext, useContext } from "react";

export const AdminAuthContext = createContext<AdminAuthState | null>(null);

export function useAdminAuthCtx(): AdminAuthState {
  const v = useContext(AdminAuthContext);
  if (!v) throw new Error("AdminAuthContext missing — wrap in <AdminGate>.");
  return v;
}

export const AdminSyncContext = createContext<AdminSyncState | null>(null);

export function useAdminSyncCtx(): AdminSyncState {
  const v = useContext(AdminSyncContext);
  if (!v) throw new Error("AdminSyncContext missing — wrap in <AdminSyncProvider>.");
  return v;
}
